var _rect, _rect2, _g, _mask, _path, _mask2, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _mask3, _path3, _g9, _mask4, _path4, _g10, _mask5, _path5, _g11, _mask6, _path6, _mask7, _path7, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _mask8, _path8, _mask9, _path9, _mask10, _path10, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _mask11, _path11, _mask12, _path12, _mask13, _path13, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _mask14, _path14, _mask15, _path15, _g34, _mask16, _path16, _path17, _path18, _mask17, _path19, _mask18, _path20, _path21, _g35, _g36, _mask19, _path22, _path23, _g37, _mask20, _path24, _mask21, _path25, _mask22, _path26, _path27, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _path28, _g45, _g46, _mask23, _path29, _mask24, _path30, _mask25, _path31, _g47, _g48, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 356,
    viewBox: "0 0 415 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 415,
    height: 356,
    fill: "#C7D0E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 415,
    height: 356,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 36,
    width: 260,
    height: 260,
    rx: 130,
    fill: "#F0F0F0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.155 278.505C338.71 275.088 335.56 272.23 331.982 270.172M342.752 277.992C341.915 275.002 340.452 272.202 338.494 269.848M344.504 278.482C343.98 275.077 343.456 271.679 342.926 268.273M78.7719 295.853C77.3264 293.839 75.4713 292.152 73.3633 290.938M79.7108 295.552C79.2169 293.79 78.3556 292.135 77.1992 290.75M80.7498 295.84C80.4426 293.832 80.1294 291.824 79.8223 289.816M80.9458 244.955C79.5002 242.941 77.6452 241.254 75.5371 240.039M81.8846 244.654C81.3908 242.892 80.5295 241.236 79.373 239.852M82.9236 244.945C82.6165 242.937 82.3033 240.93 81.9961 238.922M357.577 224.273H56.4277V224.43H357.577V224.273ZM97.2198 235.016H87.5469V235.172H97.2198V235.016ZM191.27 233.305H159.029V233.461H191.27V233.305ZM119.656 240.859H97.8223V241.016H119.656V240.859ZM310.32 233.227H284.307V233.383H310.32V233.227ZM319.498 233.227H315.686V233.383H319.498V233.227ZM279.339 237.148H246.881V237.305H279.339V237.148ZM239.576 69.4871C237.883 68.1745 235.406 68.0313 233.561 69.1291C231.119 64.0936 224.333 61.8741 219.485 64.5232C218.223 59.1057 212.99 54.9293 207.535 55.0009C202.08 55.0725 196.952 59.3683 195.819 64.8095C195.644 65.6806 195.515 66.6233 194.908 67.2557C193.927 68.2819 192.279 67.9359 190.878 67.8285C186.462 67.4705 182.012 70.6446 180.809 75L241.656 74.7733C242.193 72.6731 241.27 70.7878 239.576 69.4752V69.4871ZM414.049 251.17V250.57H413.122V223.346H407.924V216.25H395.907V191.984H389.318V174.814H381.229V149.811H378.338V174.814H370.239V191.984H363.661V216.25H351.633V223.346H346.445V251.17H344.682V212.397H341.781V237.263H338.557V178.077H335.656V202.933H327.567V193.753H323.749V160.012H321.452V159.433H317.624V125.692H314.894V130.661H270.036V115.564H262.38V62H259.389V115.564H248.731V130.661H243.815V201.691H220.857V180.383H229.057V176.235H220.857V170.908H198.987V116.459H193.537V108.164H167.849V116.459H164.011V191.616H151.993V226.546H145.838V198.722H140.64V191.616H128.623V167.35H122.034V150.2H113.945V125.176H111.064V150.2H102.965V167.35H96.3869V191.616H84.3589V198.722H79.171V226.546H71.2733V153.443H68.3821V178.298H57.9962V226.546H54.1783V134.798H50.3402V101.068H47.6204V113.006L27.8962 122.965V134.798H18.6486V226.546H12.2619V252.928H7.8899L4.84766 321.021L416.618 322V251.17H414.049ZM361.199 37.141C359.977 36.2222 358.191 36.1219 356.859 36.8904C355.098 33.3655 350.203 31.8119 346.706 33.6662C345.796 29.874 342.021 26.9505 338.087 27.0006C334.152 27.0508 330.453 30.0578 329.636 33.8667C329.509 34.4764 329.417 35.1363 328.978 35.579C328.271 36.2973 327.083 36.0551 326.072 35.9799C322.887 35.7294 319.676 37.9512 318.809 41L362.698 40.8413C363.086 39.3712 362.42 38.0514 361.199 37.1326V37.141ZM99.2358 38.483C97.2897 37.1727 94.446 37.0262 92.3404 38.1209C89.5471 33.0867 81.7457 30.8712 76.1925 33.5177C74.7329 28.1041 68.735 23.9319 62.4772 24.0008C56.2193 24.0698 50.3305 28.3627 49.0303 33.8108C48.8206 34.6728 48.6864 35.6297 47.9901 36.2589C46.8577 37.2848 44.9702 36.94 43.3596 36.8279C38.2929 36.4745 33.1843 39.6467 31.8086 44L101.635 43.7759C102.247 41.6725 101.19 39.7933 99.2442 38.483H99.2358ZM361.881 99.5486C359.65 97.7813 356.406 97.577 353.999 99.0602C350.805 92.266 341.893 89.273 335.54 92.8522C333.884 85.534 327.024 79.9122 319.868 80.001C312.713 80.0898 305.988 85.8893 304.493 93.243C304.256 94.4153 304.096 95.6942 303.302 96.5468C302.009 97.9323 299.855 97.4704 298.013 97.3195C292.218 96.8399 286.388 101.121 284.809 107L364.61 106.698C365.311 103.856 364.103 101.316 361.881 99.5486ZM128.983 105.583C127.588 104.538 125.558 104.42 124.052 105.296C122.056 101.275 116.483 99.4968 112.516 101.613C111.484 97.2799 107.196 93.9418 102.722 94.0008C98.2482 94.0513 94.0448 97.4906 93.1144 101.849C92.9707 102.54 92.8692 103.299 92.3702 103.804C91.5667 104.63 90.2135 104.352 89.0632 104.259C85.4434 103.981 81.7981 106.51 80.8086 110L130.683 109.823C131.123 108.137 130.37 106.637 128.975 105.583H128.983Z",
    stroke: "white",
    strokeWidth: 0.470237,
    strokeMiterlimit: 10
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.855 295.989C244.855 295.989 236.68 295.989 233.256 295.912C229.169 295.825 225.038 294.293 221.94 289.531C216.341 280.922 216.341 266.975 221.94 258.365C224.744 254.061 230.136 251.908 233.811 251.908H244.746C250.356 260.518 250.453 287.379 244.855 295.989Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.855 295.989C244.855 295.989 236.68 295.989 233.256 295.912C229.169 295.825 225.038 294.293 221.94 289.531C216.341 280.922 216.341 266.975 221.94 258.365C224.744 254.061 230.136 251.908 233.811 251.908H244.746C250.356 260.518 250.453 287.379 244.855 295.989Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-3-inside-1_8_2)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.889 289.541C249.28 298.151 240.203 298.151 234.593 289.541C228.984 280.932 228.984 266.985 234.593 258.375C240.203 249.766 249.28 249.766 254.889 258.375C260.498 266.985 260.498 280.932 254.889 289.541Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.889 289.541C249.28 298.151 240.203 298.151 234.593 289.541C228.984 280.932 228.984 266.985 234.593 258.375C240.203 249.766 249.28 249.766 254.889 258.375C260.498 266.985 260.498 280.932 254.889 289.541Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-4-inside-2_8_2)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.965 283.508C247.53 288.78 241.964 288.78 238.518 283.508C235.083 278.236 235.083 269.681 238.518 264.398C241.953 259.125 247.519 259.125 250.965 264.398C254.4 269.67 254.4 278.225 250.965 283.508Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.965 283.508C247.53 288.78 241.964 288.78 238.518 283.508C235.083 278.236 235.083 269.681 238.518 264.398C241.953 259.125 247.519 259.125 250.965 264.398C254.4 269.67 254.4 278.225 250.965 283.508Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-5-inside-3_8_2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-4_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.441 262.877V269.802C245.441 270.399 245.126 270.878 244.735 270.878C244.343 270.878 244.028 270.399 244.028 269.802V262.877C244.028 262.279 244.343 261.801 244.735 261.801C245.126 261.801 245.441 262.279 245.441 262.877Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.441 262.877V269.802C245.441 270.399 245.126 270.878 244.735 270.878C244.343 270.878 244.028 270.399 244.028 269.802V262.877C244.028 262.279 244.343 261.801 244.735 261.801C245.126 261.801 245.441 262.279 245.441 262.877Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-6-inside-4_8_2)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-5_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.441 278.096V285.02C245.441 285.618 245.126 286.096 244.735 286.096C244.343 286.096 244.028 285.618 244.028 285.02V278.096C244.028 277.498 244.343 277.02 244.735 277.02C245.126 277.02 245.441 277.498 245.441 278.096Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.441 278.096V285.02C245.441 285.618 245.126 286.096 244.735 286.096C244.343 286.096 244.028 285.618 244.028 285.02V278.096C244.028 277.498 244.343 277.02 244.735 277.02C245.126 277.02 245.441 277.498 245.441 278.096Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-7-inside-5_8_2)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-6_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.432 272.824C247.095 273.117 246.671 272.932 246.486 272.421C246.29 271.911 246.41 271.247 246.736 270.943L250.639 267.464C250.976 267.171 251.4 267.345 251.595 267.867C251.791 268.388 251.671 269.041 251.334 269.345L247.432 272.824Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.432 272.824C247.095 273.117 246.671 272.932 246.486 272.421C246.29 271.911 246.41 271.247 246.736 270.943L250.639 267.464C250.976 267.171 251.4 267.345 251.595 267.867C251.791 268.388 251.671 269.041 251.334 269.345L247.432 272.824Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-8-inside-6_8_2)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-7_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.888 279.997C237.692 279.476 237.812 278.823 238.149 278.519L242.052 275.04C242.389 274.736 242.823 274.91 243.019 275.432C243.215 275.954 243.095 276.617 242.758 276.91L238.856 280.389C238.519 280.693 238.084 280.508 237.888 279.987V279.997Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.888 279.997C237.692 279.476 237.812 278.823 238.149 278.519L242.052 275.04C242.389 274.736 242.823 274.91 243.019 275.432C243.215 275.954 243.095 276.617 242.758 276.91L238.856 280.389C238.519 280.693 238.084 280.508 237.888 279.987V279.997Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-9-inside-7_8_2)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-8_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.595 280.031C251.399 280.542 250.975 280.727 250.638 280.423L246.736 276.944C246.399 276.64 246.29 275.976 246.486 275.466C246.681 274.955 247.116 274.781 247.442 275.074L251.345 278.553C251.682 278.846 251.791 279.509 251.606 280.031H251.595Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.595 280.031C251.399 280.542 250.975 280.727 250.638 280.423L246.736 276.944C246.399 276.64 246.29 275.976 246.486 275.466C246.681 274.955 247.116 274.781 247.442 275.074L251.345 278.553C251.682 278.846 251.791 279.509 251.606 280.031H251.595Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-10-inside-8_8_2)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-9_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.007 272.42C242.811 272.931 242.377 273.105 242.051 272.801L238.148 269.322C237.811 269.029 237.702 268.366 237.887 267.844C238.083 267.322 238.518 267.148 238.855 267.453L242.757 270.931C243.094 271.225 243.203 271.888 243.018 272.41C243.018 272.41 243.018 272.41 243.018 272.42H243.007Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.007 272.42C242.811 272.931 242.377 273.105 242.051 272.801L238.148 269.322C237.811 269.029 237.702 268.366 237.887 267.844C238.083 267.322 238.518 267.148 238.855 267.453L242.757 270.931C243.094 271.225 243.203 271.888 243.018 272.41C243.018 272.41 243.018 272.41 243.018 272.42H243.007Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-11-inside-9_8_2)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-10_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.747 272.139C245.399 272.139 245.932 272.954 245.932 273.954C245.932 274.954 245.399 275.769 244.747 275.769C244.095 275.769 243.562 274.954 243.562 273.954C243.562 272.954 244.095 272.139 244.747 272.139Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.747 272.139C245.399 272.139 245.932 272.954 245.932 273.954C245.932 274.954 245.399 275.769 244.747 275.769C244.095 275.769 243.562 274.954 243.562 273.954C243.562 272.954 244.095 272.139 244.747 272.139Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-12-inside-10_8_2)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-11_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.889 289.541C249.28 298.151 240.203 298.151 234.593 289.541C228.984 280.932 228.984 266.985 234.593 258.375C240.203 249.766 249.28 249.766 254.889 258.375C260.498 266.985 260.498 280.932 254.889 289.541Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.889 289.541C249.28 298.151 240.203 298.151 234.593 289.541C228.984 280.932 228.984 266.985 234.593 258.375C240.203 249.766 249.28 249.766 254.889 258.375C260.498 266.985 260.498 280.932 254.889 289.541Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-13-inside-11_8_2)"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-12_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.067 283.501C201.067 283.501 197.98 249.367 219.286 249.367C219.286 249.367 230.939 249.498 232.82 265.445C234.7 281.392 233.494 283.501 233.494 283.501H201.067Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.067 283.501C201.067 283.501 197.98 249.367 219.286 249.367C219.286 249.367 230.939 249.498 232.82 265.445C234.7 281.392 233.494 283.501 233.494 283.501H201.067Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-14-inside-12_8_2)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-13_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.067 283.501C201.067 283.501 197.98 249.367 219.286 249.367C219.286 249.367 230.939 249.498 232.82 265.445C234.7 281.392 233.494 283.501 233.494 283.501H201.067Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.067 283.501C201.067 283.501 197.98 249.367 219.286 249.367C219.286 249.367 230.939 249.498 232.82 265.445C234.7 281.392 233.494 283.501 233.494 283.501H201.067Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-15-inside-13_8_2)"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-14_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.534 284.857C298.534 284.857 295.142 248.452 317.416 244.104C317.416 244.104 329.983 244.256 332.005 262.562C334.027 280.868 325.232 284.02 325.232 284.02L298.534 284.857Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.534 284.857C298.534 284.857 295.142 248.452 317.416 244.104C317.416 244.104 329.983 244.256 332.005 262.562C334.027 280.868 325.232 284.02 325.232 284.02L298.534 284.857Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-16-inside-14_8_2)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-15_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.534 284.857C298.534 284.857 295.142 248.452 317.416 244.104C317.416 244.104 329.983 244.256 332.005 262.562C334.027 280.868 325.232 284.02 325.232 284.02L298.534 284.857Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.534 284.857C298.534 284.857 295.142 248.452 317.416 244.104C317.416 244.104 329.983 244.256 332.005 262.562C334.027 280.868 325.232 284.02 325.232 284.02L298.534 284.857Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-17-inside-15_8_2)"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-16_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.034 295C318.034 295 310.435 295 307.272 294.924C303.478 294.837 299.641 293.304 296.76 288.543C291.553 279.934 291.553 265.987 296.76 257.377C299.358 253.072 304.37 250.92 307.783 250.92H317.936C323.143 259.529 323.241 286.391 318.034 295Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.034 295C318.034 295 310.435 295 307.272 294.924C303.478 294.837 299.641 293.304 296.76 288.543C291.553 279.934 291.553 265.987 296.76 257.377C299.358 253.072 304.37 250.92 307.783 250.92H317.936C323.143 259.529 323.241 286.391 318.034 295Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-18-inside-16_8_2)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-17_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.351 288.543C322.144 297.153 313.708 297.153 308.512 288.543C303.305 279.934 303.305 265.987 308.512 257.377C313.719 248.768 322.154 248.768 327.351 257.377C332.558 265.987 332.558 279.934 327.351 288.543Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.351 288.543C322.144 297.153 313.708 297.153 308.512 288.543C303.305 279.934 303.305 265.987 308.512 257.377C313.719 248.768 322.154 248.768 327.351 257.377C332.558 265.987 332.558 279.934 327.351 288.543Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-19-inside-17_8_2)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-18_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.709 282.51C320.524 287.782 315.349 287.782 312.153 282.51C308.968 277.238 308.968 268.683 312.153 263.399C315.338 258.127 320.513 258.127 323.709 263.399C326.894 268.672 326.894 277.227 323.709 282.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.709 282.51C320.524 287.782 315.349 287.782 312.153 282.51C308.968 277.238 308.968 268.683 312.153 263.399C315.338 258.127 320.513 258.127 323.709 263.399C326.894 268.672 326.894 277.227 323.709 282.51Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-20-inside-18_8_2)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-19_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.588 261.877V268.802C318.588 269.399 318.294 269.878 317.936 269.878C317.577 269.878 317.283 269.399 317.283 268.802V261.877C317.283 261.279 317.577 260.801 317.936 260.801C318.294 260.801 318.588 261.279 318.588 261.877Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.588 261.877V268.802C318.588 269.399 318.294 269.878 317.936 269.878C317.577 269.878 317.283 269.399 317.283 268.802V261.877C317.283 261.279 317.577 260.801 317.936 260.801C318.294 260.801 318.588 261.279 318.588 261.877Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-21-inside-19_8_2)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-20_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.588 277.105V284.03C318.588 284.628 318.294 285.106 317.936 285.106C317.577 285.106 317.283 284.628 317.283 284.03V277.105C317.283 276.508 317.577 276.029 317.936 276.029C318.294 276.029 318.588 276.508 318.588 277.105Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.588 277.105V284.03C318.588 284.628 318.294 285.106 317.936 285.106C317.577 285.106 317.283 284.628 317.283 284.03V277.105C317.283 276.508 317.577 276.029 317.936 276.029C318.294 276.029 318.588 276.508 318.588 277.105Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-22-inside-20_8_2)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-21_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.426 271.824C320.111 272.117 319.72 271.932 319.546 271.421C319.361 270.911 319.47 270.247 319.785 269.943L323.416 266.464C323.731 266.171 324.122 266.345 324.307 266.867C324.481 267.388 324.383 268.041 324.068 268.345L320.448 271.824H320.426Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.426 271.824C320.111 272.117 319.72 271.932 319.546 271.421C319.361 270.911 319.47 270.247 319.785 269.943L323.416 266.464C323.731 266.171 324.122 266.345 324.307 266.867C324.481 267.388 324.383 268.041 324.068 268.345L320.448 271.824H320.426Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-23-inside-21_8_2)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-22_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.566 279.011C311.392 278.489 311.49 277.837 311.805 277.533L315.425 274.054C315.74 273.75 316.142 273.924 316.316 274.445C316.501 274.967 316.392 275.63 316.077 275.924L312.457 279.402C312.142 279.707 311.74 279.522 311.566 279V279.011Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.566 279.011C311.392 278.489 311.49 277.837 311.805 277.533L315.425 274.054C315.74 273.75 316.142 273.924 316.316 274.445C316.501 274.967 316.392 275.63 316.077 275.924L312.457 279.402C312.142 279.707 311.74 279.522 311.566 279V279.011Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-24-inside-22_8_2)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-23_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.297 279.029C324.112 279.54 323.72 279.725 323.405 279.421L319.774 275.942C319.459 275.638 319.361 274.974 319.535 274.464C319.72 273.953 320.111 273.779 320.427 274.072L324.047 277.551C324.362 277.844 324.46 278.507 324.286 279.029H324.297Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.297 279.029C324.112 279.54 323.72 279.725 323.405 279.421L319.774 275.942C319.459 275.638 319.361 274.974 319.535 274.464C319.72 273.953 320.111 273.779 320.427 274.072L324.047 277.551C324.362 277.844 324.46 278.507 324.286 279.029H324.297Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-25-inside-23_8_2)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-24_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.329 271.433C316.144 271.944 315.742 272.118 315.437 271.814L311.817 268.335C311.502 268.042 311.404 267.379 311.578 266.857C311.763 266.335 312.165 266.161 312.47 266.455L316.09 269.933C316.405 270.227 316.503 270.89 316.329 271.412C316.329 271.412 316.329 271.412 316.329 271.423V271.433Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.329 271.433C316.144 271.944 315.742 272.118 315.437 271.814L311.817 268.335C311.502 268.042 311.404 267.379 311.578 266.857C311.763 266.335 312.165 266.161 312.47 266.455L316.09 269.933C316.405 270.227 316.503 270.89 316.329 271.412C316.329 271.412 316.329 271.412 316.329 271.423V271.433Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-26-inside-24_8_2)"
  }))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-25_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.935 271.139C318.544 271.139 319.033 271.954 319.033 272.954C319.033 273.954 318.544 274.769 317.935 274.769C317.327 274.769 316.837 273.954 316.837 272.954C316.837 271.954 317.327 271.139 317.935 271.139Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.935 271.139C318.544 271.139 319.033 271.954 319.033 272.954C319.033 273.954 318.544 274.769 317.935 274.769C317.327 274.769 316.837 273.954 316.837 272.954C316.837 271.954 317.327 271.139 317.935 271.139Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-27-inside-25_8_2)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-26_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.601 295.989C218.601 295.989 210.427 295.989 207.002 295.912C202.915 295.825 198.784 294.293 195.686 289.531C190.077 280.922 190.077 266.975 195.686 258.365C198.491 254.061 203.882 251.908 207.557 251.908H218.493C224.091 260.518 224.2 287.379 218.601 295.989Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.601 295.989C218.601 295.989 210.427 295.989 207.002 295.912C202.915 295.825 198.784 294.293 195.686 289.531C190.077 280.922 190.077 266.975 195.686 258.365C198.491 254.061 203.882 251.908 207.557 251.908H218.493C224.091 260.518 224.2 287.379 218.601 295.989Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-28-inside-26_8_2)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-27_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.635 289.541C223.037 298.151 213.949 298.151 208.339 289.541C202.73 280.932 202.73 266.985 208.339 258.375C213.949 249.766 223.026 249.766 228.635 258.375C234.244 266.985 234.244 280.932 228.635 289.541Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.635 289.541C223.037 298.151 213.949 298.151 208.339 289.541C202.73 280.932 202.73 266.985 208.339 258.375C213.949 249.766 223.026 249.766 228.635 258.375C234.244 266.985 234.244 280.932 228.635 289.541Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-29-inside-27_8_2)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-28_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.711 283.508C221.276 288.78 215.71 288.78 212.275 283.508C208.84 278.236 208.84 269.681 212.275 264.398C215.71 259.125 221.276 259.125 224.711 264.398C228.146 269.67 228.146 278.225 224.711 283.508Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.711 283.508C221.276 288.78 215.71 288.78 212.275 283.508C208.84 278.236 208.84 269.681 212.275 264.398C215.71 259.125 221.276 259.125 224.711 264.398C228.146 269.67 228.146 278.225 224.711 283.508Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-30-inside-28_8_2)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-29_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.199 262.877V269.802C219.199 270.399 218.884 270.878 218.493 270.878C218.101 270.878 217.786 270.399 217.786 269.802V262.877C217.786 262.279 218.101 261.801 218.493 261.801C218.884 261.801 219.199 262.279 219.199 262.877Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.199 262.877V269.802C219.199 270.399 218.884 270.878 218.493 270.878C218.101 270.878 217.786 270.399 217.786 269.802V262.877C217.786 262.279 218.101 261.801 218.493 261.801C218.884 261.801 219.199 262.279 219.199 262.877Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-31-inside-29_8_2)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-30_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.199 278.096V285.02C219.199 285.618 218.884 286.096 218.493 286.096C218.101 286.096 217.786 285.618 217.786 285.02V278.096C217.786 277.498 218.101 277.02 218.493 277.02C218.884 277.02 219.199 277.498 219.199 278.096Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.199 278.096V285.02C219.199 285.618 218.884 286.096 218.493 286.096C218.101 286.096 217.786 285.618 217.786 285.02V278.096C217.786 277.498 218.101 277.02 218.493 277.02C218.884 277.02 219.199 277.498 219.199 278.096Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-32-inside-30_8_2)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-31_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.178 272.824C220.841 273.117 220.417 272.932 220.232 272.421C220.036 271.911 220.156 271.247 220.482 270.943L224.385 267.464C224.722 267.171 225.146 267.345 225.341 267.867C225.537 268.388 225.417 269.041 225.08 269.345L221.178 272.824Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.178 272.824C220.841 273.117 220.417 272.932 220.232 272.421C220.036 271.911 220.156 271.247 220.482 270.943L224.385 267.464C224.722 267.171 225.146 267.345 225.341 267.867C225.537 268.388 225.417 269.041 225.08 269.345L221.178 272.824Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-33-inside-31_8_2)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-34-inside-32_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.634 279.997C211.439 279.476 211.558 278.823 211.895 278.519L215.798 275.04C216.135 274.736 216.569 274.91 216.765 275.432C216.961 275.954 216.841 276.617 216.504 276.91L212.602 280.389C212.265 280.693 211.83 280.508 211.634 279.987V279.997Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.634 279.997C211.439 279.476 211.558 278.823 211.895 278.519L215.798 275.04C216.135 274.736 216.569 274.91 216.765 275.432C216.961 275.954 216.841 276.617 216.504 276.91L212.602 280.389C212.265 280.693 211.83 280.508 211.634 279.987V279.997Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-34-inside-32_8_2)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-33_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.341 280.031C225.145 280.542 224.722 280.727 224.385 280.423L220.482 276.944C220.145 276.64 220.036 275.976 220.232 275.466C220.428 274.955 220.862 274.781 221.189 275.074L225.091 278.553C225.428 278.846 225.537 279.509 225.352 280.031H225.341Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.341 280.031C225.145 280.542 224.722 280.727 224.385 280.423L220.482 276.944C220.145 276.64 220.036 275.976 220.232 275.466C220.428 274.955 220.862 274.781 221.189 275.074L225.091 278.553C225.428 278.846 225.537 279.509 225.352 280.031H225.341Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-35-inside-33_8_2)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-34_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.753 272.42C216.558 272.931 216.123 273.105 215.797 272.801L211.894 269.322C211.557 269.029 211.448 268.366 211.633 267.844C211.829 267.322 212.264 267.148 212.601 267.453L216.503 270.931C216.84 271.225 216.949 271.888 216.764 272.41C216.764 272.41 216.764 272.41 216.764 272.42H216.753Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.753 272.42C216.558 272.931 216.123 273.105 215.797 272.801L211.894 269.322C211.557 269.029 211.448 268.366 211.633 267.844C211.829 267.322 212.264 267.148 212.601 267.453L216.503 270.931C216.84 271.225 216.949 271.888 216.764 272.41C216.764 272.41 216.764 272.41 216.764 272.42H216.753Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-36-inside-34_8_2)"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-37-inside-35_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.493 272.139C219.145 272.139 219.678 272.954 219.678 273.954C219.678 274.954 219.145 275.769 218.493 275.769C217.841 275.769 217.308 274.954 217.308 273.954C217.308 272.954 217.841 272.139 218.493 272.139Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.493 272.139C219.145 272.139 219.678 272.954 219.678 273.954C219.678 274.954 219.145 275.769 218.493 275.769C217.841 275.769 217.308 274.954 217.308 273.954C217.308 272.954 217.841 272.139 218.493 272.139Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-37-inside-35_8_2)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-36_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.81 295.989C128.81 295.989 120.636 295.989 117.211 295.912C113.124 295.825 108.993 294.293 105.895 289.531C100.297 280.922 100.297 266.975 105.895 258.365C108.7 254.061 114.091 251.908 117.766 251.908H128.702C134.3 260.518 134.409 287.379 128.81 295.989Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 295.989C128.81 295.989 120.636 295.989 117.211 295.912C113.124 295.825 108.993 294.293 105.895 289.531C100.297 280.922 100.297 266.975 105.895 258.365C108.7 254.061 114.091 251.908 117.766 251.908H128.702C134.3 260.518 134.409 287.379 128.81 295.989Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-38-inside-36_8_2)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-39-inside-37_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.856 289.541C133.246 298.151 124.169 298.151 118.56 289.541C112.951 280.932 112.951 266.985 118.56 258.375C124.169 249.766 133.246 249.766 138.856 258.375C144.465 266.985 144.465 280.932 138.856 289.541Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.856 289.541C133.246 298.151 124.169 298.151 118.56 289.541C112.951 280.932 112.951 266.985 118.56 258.375C124.169 249.766 133.246 249.766 138.856 258.375C144.465 266.985 144.465 280.932 138.856 289.541Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-39-inside-37_8_2)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-38_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.856 289.541C133.246 298.151 124.169 298.151 118.56 289.541C112.951 280.932 112.951 266.985 118.56 258.375C124.169 249.766 133.246 249.766 138.856 258.375C144.465 266.985 144.465 280.932 138.856 289.541Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.856 289.541C133.246 298.151 124.169 298.151 118.56 289.541C112.951 280.932 112.951 266.985 118.56 258.375C124.169 249.766 133.246 249.766 138.856 258.375C144.465 266.985 144.465 280.932 138.856 289.541Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-40-inside-38_8_2)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-39_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.931 283.508C131.496 288.78 125.931 288.78 122.485 283.508C119.05 278.236 119.05 269.681 122.485 264.398C125.92 259.125 131.485 259.125 134.931 264.398C138.367 269.67 138.367 278.225 134.931 283.508Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.931 283.508C131.496 288.78 125.931 288.78 122.485 283.508C119.05 278.236 119.05 269.681 122.485 264.398C125.92 259.125 131.485 259.125 134.931 264.398C138.367 269.67 138.367 278.225 134.931 283.508Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-41-inside-39_8_2)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-40_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.408 262.877V269.802C129.408 270.399 129.093 270.878 128.702 270.878C128.31 270.878 127.995 270.399 127.995 269.802V262.877C127.995 262.279 128.31 261.801 128.702 261.801C129.093 261.801 129.408 262.279 129.408 262.877Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.408 262.877V269.802C129.408 270.399 129.093 270.878 128.702 270.878C128.31 270.878 127.995 270.399 127.995 269.802V262.877C127.995 262.279 128.31 261.801 128.702 261.801C129.093 261.801 129.408 262.279 129.408 262.877Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-42-inside-40_8_2)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-41_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.408 278.096V285.02C129.408 285.618 129.093 286.096 128.702 286.096C128.31 286.096 127.995 285.618 127.995 285.02V278.096C127.995 277.498 128.31 277.02 128.702 277.02C129.093 277.02 129.408 277.498 129.408 278.096Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.408 278.096V285.02C129.408 285.618 129.093 286.096 128.702 286.096C128.31 286.096 127.995 285.618 127.995 285.02V278.096C127.995 277.498 128.31 277.02 128.702 277.02C129.093 277.02 129.408 277.498 129.408 278.096Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-43-inside-41_8_2)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-42_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.387 272.824C131.05 273.117 130.626 272.932 130.441 272.421C130.245 271.911 130.365 271.247 130.691 270.943L134.594 267.464C134.931 267.171 135.355 267.345 135.55 267.867C135.746 268.388 135.626 269.041 135.289 269.345L131.387 272.824Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.387 272.824C131.05 273.117 130.626 272.932 130.441 272.421C130.245 271.911 130.365 271.247 130.691 270.943L134.594 267.464C134.931 267.171 135.355 267.345 135.55 267.867C135.746 268.388 135.626 269.041 135.289 269.345L131.387 272.824Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-44-inside-42_8_2)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-43_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.855 279.997C121.659 279.476 121.779 278.823 122.116 278.519L126.018 275.04C126.355 274.736 126.79 274.91 126.986 275.432C127.181 275.954 127.062 276.617 126.725 276.91L122.822 280.389C122.485 280.693 122.051 280.508 121.855 279.987V279.997Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.855 279.997C121.659 279.476 121.779 278.823 122.116 278.519L126.018 275.04C126.355 274.736 126.79 274.91 126.986 275.432C127.181 275.954 127.062 276.617 126.725 276.91L122.822 280.389C122.485 280.693 122.051 280.508 121.855 279.987V279.997Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-45-inside-43_8_2)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-46-inside-44_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.562 280.031C135.366 280.542 134.942 280.727 134.605 280.423L130.703 276.944C130.366 276.64 130.257 275.976 130.453 275.466C130.648 274.955 131.083 274.781 131.409 275.074L135.312 278.553C135.649 278.846 135.757 279.509 135.573 280.031H135.562Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.562 280.031C135.366 280.542 134.942 280.727 134.605 280.423L130.703 276.944C130.366 276.64 130.257 275.976 130.453 275.466C130.648 274.955 131.083 274.781 131.409 275.074L135.312 278.553C135.649 278.846 135.757 279.509 135.573 280.031H135.562Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-46-inside-44_8_2)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-45_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.974 272.42C126.778 272.931 126.343 273.105 126.017 272.801L122.115 269.322C121.778 269.029 121.669 268.366 121.854 267.844C122.05 267.322 122.484 267.148 122.821 267.453L126.724 270.931C127.061 271.225 127.17 271.888 126.985 272.41C126.985 272.41 126.985 272.41 126.985 272.42H126.974Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.974 272.42C126.778 272.931 126.343 273.105 126.017 272.801L122.115 269.322C121.778 269.029 121.669 268.366 121.854 267.844C122.05 267.322 122.484 267.148 122.821 267.453L126.724 270.931C127.061 271.225 127.17 271.888 126.985 272.41C126.985 272.41 126.985 272.41 126.985 272.42H126.974Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-47-inside-45_8_2)"
  }))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-46_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.702 272.139C129.354 272.139 129.887 272.954 129.887 273.954C129.887 274.954 129.354 275.769 128.702 275.769C128.05 275.769 127.517 274.954 127.517 273.954C127.517 272.954 128.05 272.139 128.702 272.139Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.702 272.139C129.354 272.139 129.887 272.954 129.887 273.954C129.887 274.954 129.354 275.769 128.702 275.769C128.05 275.769 127.517 274.954 127.517 273.954C127.517 272.954 128.05 272.139 128.702 272.139Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-48-inside-46_8_2)"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-47_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.091 245.332C332.863 238.766 330.808 228.091 329.787 226.863C328.765 225.635 323.427 225.221 323.427 225.221C317.883 219.069 300.24 208.6 291.207 204.089C282.173 199.578 275.205 198.545 240.93 196.501C206.666 194.447 186.349 199.371 186.349 199.371C168.902 201.219 139.975 226.048 139.975 226.048C123.593 229.113 112.472 237.538 112.472 237.538C112.472 237.538 103.645 238.766 99.7536 243.082C95.851 247.387 95.4488 252.311 95.4488 252.311C95.4488 252.311 93.1878 252.311 91.9594 254.159C90.731 256.007 91.3398 268.726 91.9594 275.085C92.579 281.444 97.5034 284.314 97.5034 284.314L197.132 283.705H197.154C199.263 283.694 200.948 281.966 200.937 279.857C200.861 270.943 202.448 249.55 219.309 249.55C219.309 249.55 230.962 249.68 232.842 265.628C234.451 279.303 233.799 282.803 233.571 283.521L302.708 284.325L303.121 284.238C302.882 279.901 301.088 259.42 311.502 251.941C314.622 249.702 319.992 249.441 323.242 251.496C326.525 253.572 330.33 257.822 331.2 266.508C331.624 269.834 331.624 272.835 331.493 276.944L334.102 275.498C334.515 273.03 335.331 251.898 334.102 245.332H334.091Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M334.091 245.332C332.863 238.766 330.808 228.091 329.787 226.863C328.765 225.635 323.427 225.221 323.427 225.221C317.883 219.069 300.24 208.6 291.207 204.089C282.173 199.578 275.205 198.545 240.93 196.501C206.666 194.447 186.349 199.371 186.349 199.371C168.902 201.219 139.975 226.048 139.975 226.048C123.593 229.113 112.472 237.538 112.472 237.538C112.472 237.538 103.645 238.766 99.7536 243.082C95.851 247.387 95.4488 252.311 95.4488 252.311C95.4488 252.311 93.1878 252.311 91.9594 254.159C90.731 256.007 91.3398 268.726 91.9594 275.085C92.579 281.444 97.5034 284.314 97.5034 284.314L197.132 283.705H197.154C199.263 283.694 200.948 281.966 200.937 279.857C200.861 270.943 202.448 249.55 219.309 249.55C219.309 249.55 230.962 249.68 232.842 265.628C234.451 279.303 233.799 282.803 233.571 283.521L302.708 284.325L303.121 284.238C302.882 279.901 301.088 259.42 311.502 251.941C314.622 249.702 319.992 249.441 323.242 251.496C326.525 253.572 330.33 257.822 331.2 266.508C331.624 269.834 331.624 272.835 331.493 276.944L334.102 275.498C334.515 273.03 335.331 251.898 334.102 245.332H334.091Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-49-inside-47_8_2)"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-48_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.091 245.332C332.863 238.766 330.808 228.091 329.787 226.863C328.765 225.635 323.427 225.221 323.427 225.221C317.883 219.069 300.24 208.6 291.207 204.089C282.173 199.578 275.205 198.545 240.93 196.501C206.666 194.447 186.349 199.371 186.349 199.371C168.902 201.219 139.975 226.048 139.975 226.048C123.593 229.113 112.472 237.538 112.472 237.538C112.472 237.538 103.645 238.766 99.7536 243.082C95.851 247.387 95.4488 252.311 95.4488 252.311C95.4488 252.311 93.1878 252.311 91.9594 254.159C90.731 256.007 91.3398 268.726 91.9594 275.085C92.579 281.444 97.5034 284.314 97.5034 284.314L197.132 283.705H197.154C199.263 283.694 200.948 281.966 200.937 279.857C200.861 270.943 202.448 249.55 219.309 249.55C219.309 249.55 230.962 249.68 232.842 265.628C234.451 279.303 233.799 282.803 233.571 283.521L302.708 284.325L303.121 284.238C302.882 279.901 301.088 259.42 311.502 251.941C314.622 249.702 319.992 249.441 323.242 251.496C326.525 253.572 330.33 257.822 331.2 266.508C331.624 269.834 331.624 272.835 331.493 276.944L334.102 275.498C334.515 273.03 335.331 251.898 334.102 245.332H334.091Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.091 245.332C332.863 238.766 330.808 228.091 329.787 226.863C328.765 225.635 323.427 225.221 323.427 225.221C317.883 219.069 300.24 208.6 291.207 204.089C282.173 199.578 275.205 198.545 240.93 196.501C206.666 194.447 186.349 199.371 186.349 199.371C168.902 201.219 139.975 226.048 139.975 226.048C123.593 229.113 112.472 237.538 112.472 237.538C112.472 237.538 103.645 238.766 99.7536 243.082C95.851 247.387 95.4488 252.311 95.4488 252.311C95.4488 252.311 93.1878 252.311 91.9594 254.159C90.731 256.007 91.3398 268.726 91.9594 275.085C92.579 281.444 97.5034 284.314 97.5034 284.314L197.132 283.705H197.154C199.263 283.694 200.948 281.966 200.937 279.857C200.861 270.943 202.448 249.55 219.309 249.55C219.309 249.55 230.962 249.68 232.842 265.628C234.451 279.303 233.799 282.803 233.571 283.521L302.708 284.325L303.121 284.238C302.882 279.901 301.088 259.42 311.502 251.941C314.622 249.702 319.992 249.441 323.242 251.496C326.525 253.572 330.33 257.822 331.2 266.508C331.624 269.834 331.624 272.835 331.493 276.944L334.102 275.498C334.515 273.03 335.331 251.898 334.102 245.332H334.091Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 0.869649,
    mask: "url(#path-50-inside-48_8_2)"
  }))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-49_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.993 250.17C104.482 250.844 99.5362 257.812 99.5362 257.812C98.2643 258.486 103.645 262.432 103.645 261.791H146.019L157.477 257.878C157.085 256.921 152.65 250.67 148.921 250.17C145.193 249.66 104.993 250.17 104.993 250.17Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.993 250.17C104.482 250.844 99.5362 257.812 99.5362 257.812C98.2643 258.486 103.645 262.432 103.645 261.791H146.019L157.477 257.878C157.085 256.921 152.65 250.67 148.921 250.17C145.193 249.66 104.993 250.17 104.993 250.17Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-51-inside-49_8_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M275.749 225.766C275.749 225.766 279.847 228.559 280.043 232.364C280.239 236.169 279.141 255.268 279.032 259.378C278.836 266.443 277.912 278.977 277.912 278.977",
    stroke: "#A6BFE1",
    strokeWidth: 0.271765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M230.31 227.221C230.31 227.221 235.844 229.026 237.192 235.2C238.235 240.027 236.931 280.4 237.278 280.618L300.361 278.052L301.459 268.486C305.198 250.886 313.547 248.81 314.362 246.734C315.177 244.658 316.199 228.145 315.993 226.112C315.786 224.08 307.905 218.862 307.198 218.09",
    stroke: "#A6BFE1",
    strokeWidth: 0.271765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-50_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.018 225.449H221.471C221.471 225.449 240.669 207.426 246.234 201.697C239.277 200.654 198.338 199.904 185.772 201.697C185.772 201.697 164.216 205.567 146.029 225.449H146.018Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.018 225.449H221.471C221.471 225.449 240.669 207.426 246.234 201.697C239.277 200.654 198.338 199.904 185.772 201.697C185.772 201.697 164.216 205.567 146.029 225.449H146.018Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-54-inside-50_8_2)"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-51_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.093 225.45C230.093 225.45 250.106 205.143 254.226 203.382C258.346 201.621 272.173 202.643 277.771 203.382C283.37 204.121 303.676 212.948 307.209 218.101C307.209 218.101 303.959 222.797 298.23 224.275C292.49 225.743 293.969 224.721 281.902 225.45C269.836 226.189 230.115 227.363 230.115 227.363V225.45H230.093Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M230.093 225.45C230.093 225.45 250.106 205.143 254.226 203.382C258.346 201.621 272.173 202.643 277.771 203.382C283.37 204.121 303.676 212.948 307.209 218.101C307.209 218.101 303.959 222.797 298.23 224.275C292.49 225.743 293.969 224.721 281.902 225.45C269.836 226.189 230.115 227.363 230.115 227.363V225.45H230.093Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-55-inside-51_8_2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.461 237.354C112.461 237.354 104.145 243.735 104.993 250.181",
    stroke: "#A6BFE1",
    strokeWidth: 0.271765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-52_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4275 252.126C95.9058 252.8 96.2971 256.561 99.8192 256.593L103.635 251.876C103.635 251.876 101.906 244.571 102.993 240.418C102.993 240.418 99.5583 242.57 98.3081 244.723C97.058 246.875 95.4275 252.136 95.4275 252.136V252.126Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.4275 252.126C95.9058 252.8 96.2971 256.561 99.8192 256.593L103.635 251.876C103.635 251.876 101.906 244.571 102.993 240.418C102.993 240.418 99.5583 242.57 98.3081 244.723C97.058 246.875 95.4275 252.136 95.4275 252.136V252.126Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-57-inside-52_8_2)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-53_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.631 239.256C192.631 239.256 198.567 233.31 220.601 228.776L230.091 227.363C231.755 227.472 233.461 228.733 235.201 230.679C242.31 232.07 288.314 228.298 288.314 228.298C288.314 228.298 241.19 231.983 227.026 232.907C212.862 233.842 213.22 233.897 192.631 239.256Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.631 239.256C192.631 239.256 198.567 233.31 220.601 228.776L230.091 227.363C231.755 227.472 233.461 228.733 235.201 230.679C242.31 232.07 288.314 228.298 288.314 228.298C288.314 228.298 241.19 231.983 227.026 232.907C212.862 233.842 213.22 233.897 192.631 239.256Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-58-inside-53_8_2)"
  }))), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-54_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.569 228.875C330.427 228.799 325.492 229.527 322.188 230.386C322.188 230.386 328.699 237.68 330.862 238.039L332.602 237.712C332.602 237.712 332.297 229.831 330.569 228.885V228.875Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M330.569 228.875C330.427 228.799 325.492 229.527 322.188 230.386C322.188 230.386 328.699 237.68 330.862 238.039L332.602 237.712C332.602 237.712 332.297 229.831 330.569 228.885V228.875Z",
    fill: "#D7504D",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-59-inside-54_8_2)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.187 242.235C190.187 242.235 189.285 240.332 193.35 238.973C197.416 237.615 218.114 233.212 219.299 231.168C220.483 229.135 221.473 225.439 221.473 225.439",
    stroke: "#A6BFE1",
    strokeWidth: 0.271765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-61-inside-55_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.507 276.151C239.507 276.151 296.969 275.346 297.708 274.237C298.447 273.129 293.501 269.802 293.501 269.802C292.762 269.291 239.876 272.933 239.507 276.14V276.151Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.507 276.151C239.507 276.151 296.969 275.346 297.708 274.237C298.447 273.129 293.501 269.802 293.501 269.802C292.762 269.291 239.876 272.933 239.507 276.14V276.151Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-61-inside-55_8_2)"
  }))), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-56_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.549 250.55C128.549 251.844 126.103 252.887 123.081 252.887C120.059 252.887 117.613 251.844 117.613 250.55C117.613 249.256 120.059 248.213 123.081 248.213C126.103 248.213 128.549 249.256 128.549 250.55Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M128.549 250.55C128.549 251.844 126.103 252.887 123.081 252.887C120.059 252.887 117.613 251.844 117.613 250.55C117.613 249.256 120.059 248.213 123.081 248.213C126.103 248.213 128.549 249.256 128.549 250.55Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-62-inside-56_8_2)"
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-57_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.927 273.736C101.927 273.736 97.47 275.823 97.6439 275.834C97.8179 275.834 98.6875 280.378 98.6875 280.378L167.205 279.432L173.662 273.964L153.084 273.682L101.927 273.747V273.736Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.927 273.736C101.927 273.736 97.47 275.823 97.6439 275.834C97.8179 275.834 98.6875 280.378 98.6875 280.378L167.205 279.432L173.662 273.964L153.084 273.682L101.927 273.747V273.736Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-63-inside-57_8_2)"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-58_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.926 273.955C190.719 274.303 184.469 273.955 184.469 273.955L178.153 279.293L187.447 279.075L190.926 273.955Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M190.926 273.955C190.719 274.303 184.469 273.955 184.469 273.955L178.153 279.293L187.447 279.075L190.926 273.955Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-64-inside-58_8_2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M148.986 250.549L156.465 249.756",
    stroke: "#A6BFE1",
    strokeWidth: 0.271765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-66-inside-59_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.466 249.364C156.466 249.364 193.274 241.092 196.122 241.374C198.97 241.657 206.829 243.961 206.264 246.103C205.699 248.244 199.676 251.506 191.697 252.788C185.338 253.81 175.011 255.071 168.163 255.495C159.814 256.017 156.466 249.364 156.466 249.364Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.466 249.364C156.466 249.364 193.274 241.092 196.122 241.374C198.97 241.657 206.829 243.961 206.264 246.103C205.699 248.244 199.676 251.506 191.697 252.788C185.338 253.81 175.011 255.071 168.163 255.495C159.814 256.017 156.466 249.364 156.466 249.364Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-66-inside-59_8_2)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-67-inside-60_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.118 264.845C158.118 264.845 172.141 258.008 177.555 258.008C182.969 258.008 207.123 250.92 207.123 250.92C207.123 250.92 189.056 262.367 185.056 263.312C181.055 264.258 158.118 264.845 158.118 264.845Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.118 264.845C158.118 264.845 172.141 258.008 177.555 258.008C182.969 258.008 207.123 250.92 207.123 250.92C207.123 250.92 189.056 262.367 185.056 263.312C181.055 264.258 158.118 264.845 158.118 264.845Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-67-inside-60_8_2)"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-61_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.291 223.853C150.291 223.853 170.673 205.351 187.675 203.633C204.687 201.905 215.297 202.405 215.297 202.405C215.297 202.405 210.242 215.363 200.915 217.917C191.577 220.483 150.291 223.853 150.291 223.853Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.291 223.853C150.291 223.853 170.673 205.351 187.675 203.633C204.687 201.905 215.297 202.405 215.297 202.405C215.297 202.405 210.242 215.363 200.915 217.917C191.577 220.483 150.291 223.853 150.291 223.853Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-68-inside-61_8_2)"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-69-inside-62_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6436 255.529C92.6436 255.529 92.1653 259.182 93.0458 260.867C93.9264 262.563 102.145 264.802 102.145 264.802L92.6436 255.529Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.6436 255.529C92.6436 255.529 92.1653 259.182 93.0458 260.867C93.9264 262.563 102.145 264.802 102.145 264.802L92.6436 255.529Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-69-inside-62_8_2)"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-70-inside-63_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.328 248.278C192.328 250.55 189.85 252.398 186.806 252.398C183.762 252.398 181.284 250.55 181.284 248.278C181.284 246.006 183.762 244.158 186.806 244.158C189.85 244.158 192.328 246.006 192.328 248.278Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.328 248.278C192.328 250.55 189.85 252.398 186.806 252.398C183.762 252.398 181.284 250.55 181.284 248.278C181.284 246.006 183.762 244.158 186.806 244.158C189.85 244.158 192.328 246.006 192.328 248.278Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-70-inside-63_8_2)"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-64_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.198 243.842L196.133 243.06C196.133 243.06 198.492 248.006 193.796 250.908C193.796 250.908 199.59 249.201 197.829 243.06C197.72 242.516 197.47 241.962 196.133 242.244C195.698 242.331 188.198 243.842 188.198 243.842Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.198 243.842L196.133 243.06C196.133 243.06 198.492 248.006 193.796 250.908C193.796 250.908 199.59 249.201 197.829 243.06C197.72 242.516 197.47 241.962 196.133 242.244C195.698 242.331 188.198 243.842 188.198 243.842Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-71-inside-64_8_2)"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-65_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.648 226.483C144.648 226.483 114.135 231.472 108.699 246.528C108.699 246.528 187.142 227.015 186.794 226.483C186.446 225.95 144.638 226.483 144.638 226.483H144.648Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.648 226.483C144.648 226.483 114.135 231.472 108.699 246.528C108.699 246.528 187.142 227.015 186.794 226.483C186.446 225.95 144.638 226.483 144.638 226.483H144.648Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-72-inside-65_8_2)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M230.093 225.45C230.093 225.45 250.106 205.143 254.226 203.382C258.346 201.621 272.173 202.643 277.771 203.382C283.37 204.121 303.676 212.948 307.209 218.101C307.209 218.101 303.959 222.797 298.23 224.275C292.49 225.743 293.969 224.721 281.902 225.45C269.836 226.189 230.115 227.363 230.115 227.363V225.45H230.093Z",
    stroke: "#A6BFE1",
    strokeWidth: 0.271765,
    strokeMiterlimit: 10
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-74-inside-66_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.793 236.41L274.587 235.873C275.419 235.807 276.147 236.428 276.213 237.26L276.272 238.008C276.338 238.84 275.717 239.568 274.885 239.633L268.09 240.17C267.258 240.236 266.53 239.615 266.465 238.783L266.406 238.036C266.34 237.204 266.961 236.476 267.793 236.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.793 236.41L274.587 235.873C275.419 235.807 276.147 236.428 276.213 237.26L276.272 238.008C276.338 238.84 275.717 239.568 274.885 239.633L268.09 240.17C267.258 240.236 266.53 239.615 266.465 238.783L266.406 238.036C266.34 237.204 266.961 236.476 267.793 236.41Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-74-inside-66_8_2)"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-75-inside-67_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.021 232.646L309.816 232.109C310.648 232.044 311.376 232.665 311.441 233.497L311.5 234.244C311.566 235.076 310.945 235.804 310.113 235.87L303.319 236.407C302.487 236.473 301.759 235.852 301.693 235.02L301.634 234.272C301.568 233.44 302.189 232.712 303.021 232.646Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.021 232.646L309.816 232.109C310.648 232.044 311.376 232.665 311.441 233.497L311.5 234.244C311.566 235.076 310.945 235.804 310.113 235.87L303.319 236.407C302.487 236.473 301.759 235.852 301.693 235.02L301.634 234.272C301.568 233.44 302.189 232.712 303.021 232.646Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-75-inside-67_8_2)"
  }))), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-68_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.161 202.893C273.541 202.926 277.9 225.765 277.9 225.765H271.574L268.639 202.578C268.639 202.578 272.78 202.861 273.161 202.893Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M273.161 202.893C273.541 202.926 277.9 225.765 277.9 225.765H271.574L268.639 202.578C268.639 202.578 272.78 202.861 273.161 202.893Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-76-inside-68_8_2)"
  })), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-69_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.799 218.775L240.201 226.885L230.092 227.363V225.276L236.799 218.775Z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M236.799 218.775L240.201 226.885L230.092 227.363V225.276L236.799 218.775Z",
    fill: "#A6BFE1",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-77-inside-69_8_2)"
  })), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-78-inside-70_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.289 221.252C251.235 221.176 251.18 221.111 251.126 221.035C249.811 219.22 243.951 216.915 238.342 218.807C234.255 220.187 234.983 225.003 235.69 227.503C236.027 228.699 237.027 229.59 238.266 229.775C241.625 230.264 247.821 229.775 249.398 228.96C249.485 228.916 249.572 228.873 249.648 228.818C252.354 227.296 253.126 223.753 251.289 221.252Z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M251.289 221.252C251.235 221.176 251.18 221.111 251.126 221.035C249.811 219.22 243.951 216.915 238.342 218.807C234.255 220.187 234.983 225.003 235.69 227.503C236.027 228.699 237.027 229.59 238.266 229.775C241.625 230.264 247.821 229.775 249.398 228.96C249.485 228.916 249.572 228.873 249.648 228.818C252.354 227.296 253.126 223.753 251.289 221.252Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-78-inside-70_8_2)"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-79-inside-71_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.289 221.252C251.235 221.176 251.18 221.111 251.126 221.035C249.811 219.22 243.951 216.915 238.342 218.807C234.255 220.187 234.983 225.003 235.69 227.503C236.027 228.699 237.027 229.59 238.266 229.775C241.625 230.264 247.821 229.775 249.398 228.96C249.485 228.916 249.572 228.873 249.648 228.818C252.354 227.296 253.126 223.753 251.289 221.252Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.289 221.252C251.235 221.176 251.18 221.111 251.126 221.035C249.811 219.22 243.951 216.915 238.342 218.807C234.255 220.187 234.983 225.003 235.69 227.503C236.027 228.699 237.027 229.59 238.266 229.775C241.625 230.264 247.821 229.775 249.398 228.96C249.485 228.916 249.572 228.873 249.648 228.818C252.354 227.296 253.126 223.753 251.289 221.252Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-79-inside-71_8_2)"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-72_8_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.647 220.297C237.647 220.297 239.017 219.231 241.462 219.112C243.897 218.992 250.278 219.47 251.148 223.069C252.018 226.667 234.603 221.416 237.647 220.297Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.647 220.297C237.647 220.297 239.017 219.231 241.462 219.112C243.897 218.992 250.278 219.47 251.148 223.069C252.018 226.667 234.603 221.416 237.647 220.297Z",
    fill: "white",
    stroke: "#A6BFE1",
    strokeWidth: 2.17412,
    mask: "url(#path-80-inside-72_8_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 36,
    width: 260,
    height: 260,
    rx: 130,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.ac4b95eaba70dc09104ca195f8b4b5a3.svg";
export { ForwardRef as ReactComponent };